import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './BoardProject.css';

const BoardProject = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['मंडळ प्रकल्प', 'प्रकल्प', 'योजना'],
    en: ['board project', 'project', 'scheme']
  });

  const pageHeaderData = {
    title: {
      marathi: 'मंडळ प्रकल्प',
      english: 'Board Project'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाचे प्रकल्प',
      english: 'Board Projects of Maharashtra Labour Welfare Board'
    }
  };

  const tableData = {
    marathi: {
      title: 'मंडळातील केंद्राचे वर्गीकरण',
      headers: ['क्र.', 'केंद्र प्रकार', 'संख्या'],
      rows: [
        { no: '1.', type: 'प्रकल्प', number: '03' },
        { no: '2.', type: 'कामगार कल्याण भवन', number: '15' },
        { no: '3.', type: 'ललित कला भवन', number: '21' },
        { no: '4.', type: 'कामगार कल्याण केंद्र / उपकेंद्र', number: '192' },
        { no: '', type: 'एकूण', number: '231' }
      ]
    },
    english: {
      title: 'THE CLASS CATEGORIZATION OF THE WELFARE CENTERS',
      headers: ['No.', 'Center type', 'Number'],
      rows: [
        { no: '1.', type: 'Project', number: '03' },
        { no: '2.', type: 'Kamgar Kalyan Bhawan', number: '15' },
        { no: '3.', type: 'Lalit Kala Bhawan', number: '21' },
        { no: '4.', type: 'Kamgar Kalyan Kendra / Upakendra', number: '192' },
        { no: '', type: 'Total', number: '231' }
      ]
    }
  };

  const content = {
    marathi: {
      mainTitle: 'मंडळातील केंद्राचे वर्गीकरण',
      sectionA: {
        title: 'अ) कामगार क्रीडा भवन, प्रभादेवी, मुंबई:',
        description: 'कामगार कल्याण मंडळाचे पहिले सुसज्ज बहुउद्देशीय असे कामगार क्रीडा भवन असून या भवनांचे उदघाटन तत्कालीन राष्ट्रपती श्री. व्ही. गिरी यांचा शुभहस्ते दि. १८ ऑगस्ट १९७१ रोजी झाले.  ह्या वास्तूमध्ये ऑलंपीक दर्जा जलतरण तलाव खुला रंगमंच कब्बडी, ऍथलेटिकस इ. मैदानी खेळांसाठी क्रीडांगण, व्योमशाला योगवर्ग, बंदिस्त बॅडमिंटन कोर्ट, टेबलं टेनिस कोर्ट व इतर अंतर्गृह खेळ, सुसज्ज ग्रंथालय, अभ्यासिका, समिती सभागृह, पुरुष व स्त्रीयांसाठी शिवणीवर्ग, शिशुमंदिर इ. सुविधा आहेत.'
      },
      sectionB: {
        title: 'ब) कामगारकल्याणभवन, राजे  रघुजी  नगर, नागपुर:',
        description: 'हा मंडळाचा दूसरा बहुउद्देशीय प्रकल्प आहे. या प्रकल्पात जलतरण तलाव, व्यायामशाला, ग्रंथालय, आभासिका, संगणक प्रषिषण वर्ग, सरकार मान्य  व मंडळाचा शिवण वर्ग, फैशन डिज़ायनिंग, शिशुमंदिर, टेबल टेनिस, योगावर्ग, स्वयंरोजगार प्रशिक्षण, समिति सभागृह ईत्यादी सुविधा आहेत.'
      },
      sectionC: {
        title: 'क) कामगार कल्याण भवन, सहकर नगर पुणे:',
        description: 'हा मंडळाचा तीसरा प्रकल्प असून या ठिकाणी जलतरण तलाव, व्यायामशाळा, ग्रंथालय, अभ्यासिका, संगणक प्रशिक्षण वर्ग, सरकार मान्य  मंडळाचा शिवण वर्ग, फैशन डिज़ायनिंग, शिशुमंदिर, टेबल टेनिस, योगावर्ग, स्वयंरोजगार प्रशिक्षण, समिति सभागृह ईत्यादी सुविधा आहेत.'
      },
      sectionD: {
        title: 'कामगार कल्याण भवन / ललित कला भवन:',
        description: 'विविध मैदानी खेळातील आवश्यक असलेल्या मोकळ्या मैदानात योग्य बांधणीची ईमारत, त्यात बैठ्या व मैदानी खेळाची सोय, तसेच व्यायामशाळा, कुस्तीचे आखाड़े, वाचनालय, ग्रंथालय, अभ्यासिका, शिवणवर्ग, शिशुमंदिर, बालसंगोपन, खुले नाट्यगृह, संगीतवर्ग इ. उपक्रम राबविले जातात.'
      },
      sectionE: {
        title: 'कामगार कल्याण केंद्र:',
        description: 'स्वमालकीचा अथवा भाड्याने घेतलेल्या जागेत सुरु केलेल्या ह्या केंद्रातून प्रामुख्याने आंतरगृह खेळ, मैदानाची सोय असल्यास मैदानी खेळ, शैक्षणिक इ. उपक्रम राबविले जातात.'
      },
      sectionF: {
        title: 'कामगार वसाहतीतील कल्याणकार्य:',
        description: 'सर्वच कामगार वसाहतीत जागेच्या व आर्थिक अडचणीमुळे कामगार कल्याण केंद्र उघडणे मंडळाला शक्य होत नाही. अशा ठिकाणी मनोरंज़नात्मक, शैक्षणिक, खेळ व स्पर्धा असे कल्याणकारी कार्यक्रम राबविण्यात येतात. वर्षभरात साधारणपणे ४ प्रासंगिक स्वरूपाचे कार्यक्रम आयोजित करून मंडळाच्या कल्याणकारी कार्याचा फायदा या वसाहतीतील कामगार व त्यांच्या कुटुंबियांना मिळवून देण्यात येतो.'
      }
    },
    english: {
      mainTitle: 'THE CLASS CATEGORIZATION OF THE WELFARE CENTERS',
      sectionA: {
        title: 'A) Kamgar Krida Bhawan, Prabhadevi, Mumbai (Stadium – Mumbai):',
        description: 'This was the first multipurpose Kamgar Krida Bhwan of the board.The stadium was inaugurated on 18th August 1971 by the then President of India Shri V. Giri. The stadium is well-equipped multi-purpose sports arena along with open ground for sporting and socio-cultural activities.The stadium is equipped with an Olympic size swimming pool, open theater, athletics playground for outdoor sports like kabaddi, athletics, modern equipped gymnasium for youth, yoga center, badminton courts, table tennis courts, indoor games section, furnished library, study hall, community hall, cottage for men and women, shishu mandir (creche), sewing classes etc.'
      },
      sectionB: {
        title: 'B) Kamgar Kalyan Bhawan, RajeRaghuji Nagar, Nagpur (Project-Nagpur):',
        description: 'It is the second multipurpose project of the Board and is one of the most important assets. This Project includes swimming pools, gymnasiums, well equipped library, computer training classes, Government recognized and Board\'s own sewing classes, fashion designing, shishu mandir (creche), table tennis, yoga, community hall etc.'
      },
      sectionC: {
        title: 'C) Kamgar Kalyan Bhawan, Sahakar Nagar, Pune,(Project–Pune):',
        description: 'It is the third project of the board which is equipped with large size swimming pool, modern gymnasium, well maintained library, study center, computer training classes, government recognized and board\'s own Sewing class, fashion designing classes,shishu mandir (creche), table tennis, yoga center, state of the art badminton court etc.'
      },
      sectionD: {
        title: 'Kamgar Kalyan Bhawan / Lalit Kala Bhavan:',
        description: 'These are specially designed welfare center where there are facilities such as open ground for different outdoor games like kabaddi etc.Such a building also includes spaces for indoor games like table tennis, badminton, wrestling rings, modern gymnasium,library, reading rooms, sewing class, shishu mandir (creche), computer training institute, playschools, open auditorium for plays and dramas, music class etc.'
      },
      sectionE: {
        title: 'Kamgar Kalyan Center:',
        description: 'These types of centers are usually run by the board which can cater to a limited number of beneficiaries and these types of centers are run by the board all across the State. They may be either rented centers or board\'s own centers. Mostly the facilities provided in such centers are indoor games, educational program, handicraft classes, fashion designing and sewing classes, creche and playschools for toddlers are available as per the availability of the space. They are mostly situated in those areas where the population density of labour are higher.'
      },
      sectionF: {
        title: 'Kamgar Kalyan Upkendra:',
        description: 'These types of centers are located in the vicinity of the slum areas and mainly the facilities provided through such centers are health and wellness related training, selected indoor games, library, sewing classes for women, creche for toddlers, organizing different sport competitions and entertainment events.'
      },
      sectionG: {
        title: 'Gramin Kendra:',
        description: 'These are the rural centers which were inaugurated in the year 1963-64 plantation year for the rural labors in the areas like Hingna-Nagpur, Ganori-Aurangabad, Malgud-Pune and Kulgaon-Badlapur (Thane). In the year 1988-89 "Golden Jubilee Year" one more such center was inaugurated at Pipalgaon Baswant-Nashik. The facilities provided in these centers are crèche for toddlers, sewing classes for women, library, study centers / reading rooms, indoor and outdoor games.'
      },
      sectionH: {
        title: 'Samiti Kendra:',
        description: 'Apart from the above-mentioned welfare centers, in the year 1983-84 the board has inaugurated welfare centers in the vicinity of sugar mills to cater to the sugar mill workers. The facilities provided in these centers are creche for toddlers, sewing classes for women, library, study centers / reading rooms, indoor and outdoor games.'
      }
    }
  };

  const currentContent = isMarathi() ? content.marathi : content.english;
  const currentTableData = isMarathi() ? tableData.marathi : tableData.english;

  return (
    <div className="board-project">
      <div className="board-project-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        {/* Main Content */}
        <div className="board-project-content">
          {/* All content in one single box */}
          <section className="board-project-section overview-section" data-read-section="board-project-content">
            <h2 className="section-title">
              {currentContent.mainTitle}
            </h2>
            
            <div className="section-content">
              <div className="section-text">
                {/* Section A */}
                <h3>{currentContent.sectionA.title}</h3>
                <p>{currentContent.sectionA.description}</p>

                {/* Section B */}
                <h3>{currentContent.sectionB.title}</h3>
                <p>{currentContent.sectionB.description}</p>

                {/* Section C */}
                <h3>{currentContent.sectionC.title}</h3>
                <p>{currentContent.sectionC.description}</p>

                {/* Section D */}
                <h3>{currentContent.sectionD.title}</h3>
                <p>{currentContent.sectionD.description}</p>

                {/* Section E */}
                <h3>{currentContent.sectionE.title}</h3>
                <p>{currentContent.sectionE.description}</p>

                {/* Section F */}
                <h3>{currentContent.sectionF.title}</h3>
                <p>{currentContent.sectionF.description}</p>

                {/* Section G & H (English only) */}
                {!isMarathi() && (
                  <>
                    <h3>{currentContent.sectionG.title}</h3>
                    <p>{currentContent.sectionG.description}</p>

                    <h3>{currentContent.sectionH.title}</h3>
                    <p>{currentContent.sectionH.description}</p>
                  </>
                )}
              </div>
            </div>
          </section>

          {/* Table Section */}
          <section className="board-project-section overview-section" data-read-section="board-project-table">
            <div className="board-project-table-container">
              <table className="board-project-table">
                <thead>
                  <tr>
                    {currentTableData.headers.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {currentTableData.rows.map((row, index) => (
                    <tr key={index} className={index === currentTableData.rows.length - 1 ? 'total-row' : ''}>
                      <td className="table-no">{row.no}</td>
                      <td className="table-type">{row.type}</td>
                      <td className="table-number">{row.number}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BoardProject;

